export default "__VITE_ASSET__Bpcsde6n__"